import { TimeUnit } from '@mews/enums';
import NightsCountLabel from './NightsCountLabel';
import MonthsCountLabel from './MonthsCountLabel';

interface TimeUnitCountsLabelProps {
    timeUnit: TimeUnit;
    startUtc: string | undefined;
    endUtc: string | undefined;
}

const TimeUnitCountLabel = ({ timeUnit, ...other }: TimeUnitCountsLabelProps) =>
    timeUnit === TimeUnit.Day ? <NightsCountLabel {...other} /> : <MonthsCountLabel {...other} />;

export default TimeUnitCountLabel;
